import { Button, cn } from "@cloudflare/kumo";
import { CheckIcon, CopyIcon } from "@phosphor-icons/react";
import { useKVClipboard } from "./react.tsx";

// Adapted from workers-sdk's local-explorer-ui CopyButton. Reveals on
// hover of the surrounding `group/cell` element.
export function CopyButton({ text }: { text: string }) {
  const { copied, copy } = useKVClipboard(text);
  return (
    <Button
      className={cn(
        "h-6 w-6 p-0 opacity-0 transition-[opacity,background-color,color] group-hover/cell:opacity-100",
        { "text-kumo-success opacity-100": copied }
      )}
      onClick={() => copy()}
      aria-label={copied ? "Copied" : "Copy to clipboard"}
      variant="ghost"
      shape="square"
    >
      {copied ? <CheckIcon size={14} weight="bold" /> : <CopyIcon size={14} />}
    </Button>
  );
}
